import { handleActions } from 'redux-actions';
import get from 'lodash/get';
import { getKytRulesSuccess, getKytRulesFail, updateKytRuleSuccess } from '../actions';

const defaultState = {
  rules: undefined,
};

export default handleActions(
  {
    [getKytRulesSuccess]: (state, action) => ({
      ...state,
      rules: get(action, 'response.data', []),
    }),
    [getKytRulesFail]: (state) => ({
      ...state,
      rules: [],
    }),
    [updateKytRuleSuccess]: (state, action) => {
      const updatedRule = get(action, 'response.data');

      if (!updatedRule || !updatedRule._id) {
        return state;
      }
      const updatedRules = state.rules.map((rule) =>
        rule._id === updatedRule._id ? updatedRule : rule,
      );

      return {
        ...state,
        rules: updatedRules,
      };
    },
  },
  defaultState,
);
